export default {
  getdevelopmentFileList: state => {
    return state.treePermitDetails;
  },
  getErrors: state => {
    return state.errors;
  },
  getConfiguration: state => {
    return state.configuration;
  },
  getdevelopmentFileList: state => {
    return state.developmentFileList;
  }
};
